import { HttpClientModule } from '@angular/common/http';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import 'reflect-metadata';
import { ConfirmationService } from 'primeng/api';

export interface ICoreServiceConfig {
  services: {
    auth: {
      url: string;
    };
  };
}

export class MsCoreModuleConfig implements ICoreServiceConfig {
  services = {
    auth: {
      url: '',
    },
  };
}

@NgModule({
  declarations: [],
  imports: [HttpClientModule],
  exports: [HttpClientModule],
  providers: [ConfirmationService],
})
export class MsCoreModule {
  constructor(@Optional() @SkipSelf() parentModule?: MsCoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }

  static forRoot(
    config: ICoreServiceConfig
  ): ModuleWithProviders<MsCoreModule> {
    return {
      ngModule: MsCoreModule,
      providers: [
        ConfirmationService,
        { provide: MsCoreModuleConfig, useValue: config },
      ],
    };
  }
}
